/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function RemoveCircleIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "remove-circle", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("line", { x1: 8, y1: 12.4, x2: 17, y2: 12.4, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(RemoveCircleIcon);
export default ForwardRef;
//# sourceMappingURL=removeCircleIcon.js.map